import rootLogger from '@/utils/root-logger';

const mixin = {
  beforeCreate() {
    let parentLogger = rootLogger;
    let name = '';

    if (this.$options) {
      name = this.$options.name || '';

      if (!name && this.$options.$vnode) {
        name = this.$options.$vnode.tag || '';
      }
    }

    if (this.$parent && this.$parent.logger) {
      parentLogger = this.$parent.logger;
    }

    this.logger = parentLogger.create(name);

    this.logger.startLoggingService = rootLogger.startLoggingService;

    this.logger.setRootContext = (field, value) => {
      rootLogger.setContext(field, value);
    };
  }
};

export default mixin;
